import React from 'react';
import { Phone, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo, images } from '../data/mock';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center pt-24 pb-16 overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={images.hero}
          alt="Beautiful lawn"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark/90 via-brand-dark/70 to-brand-dark/40" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-brand-primary rounded-full px-4 py-2 mb-6 animate-fade-in shadow-lg">
            <span className="w-2 h-2 bg-brand-dark rounded-full animate-pulse" />
            <span className="text-brand-dark text-sm font-bold">
              Free Estimates Available
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight animate-slide-up">
            {companyInfo.name}
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl lg:text-3xl text-brand-primary font-semibold mb-6 animate-slide-up animation-delay-100">
            {companyInfo.tagline}
          </p>

          {/* Description */}
          <p className="text-lg text-white/80 mb-8 max-w-xl leading-relaxed animate-slide-up animation-delay-200">
            Transform your outdoor space with our expert lawn care, landscaping,
            and hardscape services. Serving residential and commercial
            properties with dedication and quality craftsmanship.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-slide-up animation-delay-300">
            <Button
              onClick={scrollToContact}
              className="bg-brand-primary text-brand-dark hover:bg-brand-primary/90 rounded-full px-8 py-6 text-lg font-bold flex items-center justify-center gap-2 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              Get a Free Estimate
              <ArrowRight size={20} />
            </Button>
            <a href={`tel:${companyInfo.phone}`}>
              <Button
                variant="outline"
                className="bg-white border-2 border-white text-brand-dark hover:bg-brand-primary hover:border-brand-primary rounded-full px-8 py-6 text-lg font-bold flex items-center justify-center gap-2 transition-all duration-300 hover:-translate-y-1 w-full sm:w-auto shadow-lg"
              >
                <Phone size={20} />
                {companyInfo.phone}
              </Button>
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 flex flex-wrap items-center gap-8 animate-fade-in animation-delay-400">
            <div className="flex items-center gap-3 bg-white rounded-2xl px-5 py-3 shadow-lg">
              <div className="w-12 h-12 bg-brand-primary rounded-full flex items-center justify-center">
                <span className="text-brand-dark font-bold text-xl">5★</span>
              </div>
              <div>
                <p className="text-brand-dark font-bold">Top Rated</p>
                <p className="text-text-secondary text-sm">Customer Reviews</p>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white rounded-2xl px-5 py-3 shadow-lg">
              <div className="w-12 h-12 bg-brand-primary rounded-full flex items-center justify-center">
                <span className="text-brand-dark font-bold text-lg">LLC</span>
              </div>
              <div>
                <p className="text-brand-dark font-bold">Licensed</p>
                <p className="text-text-secondary text-sm">Fully Insured</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-bg-page to-transparent z-10" />
    </section>
  );
};

export default Hero;
